import { MenuItem } from '@mui/material';
import type { ReactNode } from 'react';

import VNFieldHelpItemTipIcon from './VNFieldHelpItemTipIcon';

type Props = {
  value: string | number;
  label: ReactNode;
  itemHelperText?: string;
  itemTooltip?: string;
  selected?: boolean;
  onClick?: () => void;
  menuItemProps?: Record<string, unknown>;
};

const VNFieldHelpMenuItem = ({ value, label, itemHelperText, itemTooltip, selected, onClick, menuItemProps }: Props) => (
  <MenuItem
    {...menuItemProps}
    value={value}
    selected={selected}
    onClick={onClick}
    className={['vn-field-help-menu-item', menuItemProps?.className].filter(Boolean).join(' ')}
  >
    <div className="vn-field-help-menu-item__content">
      <div className="vn-field-help-menu-item__main">
        <span className="vn-field-help-menu-item__label">{label}</span>
        {itemTooltip && <VNFieldHelpItemTipIcon tooltip={itemTooltip} />}
      </div>
      {itemHelperText && <span className="vn-field-help-menu-item__subtext">{itemHelperText}</span>}
    </div>
  </MenuItem>
);

export default VNFieldHelpMenuItem;
